import Applicant from '@/components/services/StorageAccept/Applicant/Manual/index.vue';

import StorageAcceptDetails from '@/components/services/StorageAccept/StorageAcceptDetails.vue';
import AccountBankDetails from '@/components/services/StorageAccept/AccountBankDetails.vue';
import StepDocuments from '@/components/services/common/StepDocuments.vue';

import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType.vue';
import SubjectFillType from '@/components/services/common/SubjectFillType.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const commonSteps: unknown[] = [
  StorageAcceptDetails,
  AccountBankDetails,
  StepDocuments,
];
const steps: unknown[] = [Applicant, ...commonSteps];

const mrpaSteps: unknown[] = [
  SelectSubjectFillType,
  SubjectFillType,
  ...commonSteps,
];

export const storageAcceptSteps: unknown[] = isMrpaEnable(StatementType.STORAGE_ACCEPT) ? mrpaSteps : steps;
